export default __webpack_public_path__ + "static/media/subject.80d13238.svg";